<template>
    <div
        v-if="cartLine?.recipientName && cartLine.senderName"
    >
        <v-chip
            class="border border-opacity-25 flex-shrink-0"
            v-bind="$attrs"
            variant="flat"
            color="info"
            label
        >
            <div
                class="d-flex gap-2"
            >
                <span><strong>TO</strong> {{ cartLine.recipientName }}</span>
                <span><strong>FROM</strong> {{ cartLine.senderName }}</span>
            </div>
        </v-chip>

        <br />
    </div>
</template>

<script lang="ts" setup>
    import type { CartLine } from '~/types';
    
    defineProps({
        cartLine: {
            type: Object as PropType<Nilish<CartLine>>,
            default: null
        }
    });

    defineOptions({
        inheritAttrs: false
    });
</script>

<style lang="scss"></style>
